import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
// import { Helmet } from 'react-helmet';
import styles from '../../../common/styles';

import MyContext from '../../../services/context';
import homeImage from '../../../static/splash-stroke.jpg';
import TitleComponent from '~/src/common/components/TitleComponent';
import WhitePad from '~/src/common/components/WhitePad';

export default function Stroke() {
  const [windowHeight, setWindowHeight] = useState(0);
  const context = useContext(MyContext);

  useEffect(() => {
    context.setShowStrokePlain(false);
    context.setTitle('Home');
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <WhitePad>
        <WrapperImage
          style={{
            height: windowHeight * 0.7,
          }}
        >
          <HomeImage src={homeImage} />
        </WrapperImage>
        {/* <TitleComponent title="The Brushstroke = One Human Helping Another" /> */}
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Title style={{ whiteSpace: 'nowrap' }}>The Brushstroke</Title>
          <Title style={{ margin: '0 6px' }}> = </Title>
          <Title style={{ textAlign: 'left' }}>One Human Helping Another</Title>
        </div>

        <br />
        <br />
        <TitleComponent title="Dear Visitor," Heading="h3" />
        <p>
          A stroke is the simplest touch you can do with a brush and normally
          doesn't carry much meaning. These brushstrokes, however, are loaded
          with significance and they all mean a single thing -{' '}
          <b>one human helping another</b>. And so this entire project is all
          about help, human help.
        </p>

        <p>
          For now, browse around and enjoy the{' '}
          <Link to="/paper-collection">collection of 1300 brushstrokes</Link>{' '}
          that change paper, brushes, colors, pigments as well as the{' '}
          <Link to="/experimental-projects">experimental projects</Link>, which
          are probably{' '}
          <b>
            <i>
              <u>things</u>
            </i>
          </b>{' '}
          you haven't seen before.
        </p>

        <p>
          When start wondering, "What is this all about?", then it is time to
          head for the <Link to="/about">about</Link> page where the concept is
          fully explained.
        </p>

        <p>
          If you later choose to be part of it, you can find out how to{' '}
          <Link to="/get-involved">get involved</Link>.
        </p>
      </WhitePad>
      {/* Instagram gallery removed — token expired and API discontinued */}
      <WhitePad>
        <p></p>
      </WhitePad>
    </>
  );
}

const Title = styled.h1``;

const WrapperImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const HomeImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
